import React, { useState } from 'react';

const SurveyPage = () => {
  const [surveys, setSurveys] = useState([
    {
      id: 1,
      title: "Çalışan Memnuniyet Anketi 2024",
      description: "Şirketimizdeki çalışma koşulları ve memnuniyet düzeyinizi değerlendirmek için bu anketi doldurun.",
      status: "active",
      questions: 15,
      responses: 89,
      deadline: "2024-12-31",
      createdBy: "İnsan Kaynakları"
    },
    {
      id: 2,
      title: "Yeni Ofis Düzenlemesi Hakkında Görüşler",
      description: "Yeni ofis düzenlemesi hakkındaki düşüncelerinizi paylaşın.",
      status: "active",
      questions: 8,
      responses: 45,
      deadline: "2024-12-15",
      createdBy: "Genel Müdürlük"
    },
    {
      id: 3,
      title: "Eğitim İhtiyaçları Değerlendirmesi",
      description: "Hangi konularda eğitim almak istediğinizi belirtin.",
      status: "completed",
      questions: 12,
      responses: 156,
      deadline: "2024-11-30",
      createdBy: "Kolin Akademi"
    }
  ]);

  const [showCreateForm, setShowCreateForm] = useState(false);
  const [newSurvey, setNewSurvey] = useState({
    title: '',
    description: '',
    deadline: '',
    questions: []
  });
  const [currentStep, setCurrentStep] = useState(1); // 1: Temel bilgiler, 2: Sorular

  const handleCreateSurvey = (e) => {
    e.preventDefault();
    const survey = {
      id: surveys.length + 1,
      title: newSurvey.title,
      description: newSurvey.description,
      status: "active",
      questions: newSurvey.questions.length,
      responses: 0,
      deadline: newSurvey.deadline,
      createdBy: "Siz",
      questionList: newSurvey.questions
    };
    setSurveys([...surveys, survey]);
    setNewSurvey({ title: '', description: '', deadline: '', questions: [] });
    setCurrentStep(1);
    setShowCreateForm(false);
  };

  const addQuestion = (type) => {
    const newQuestion = {
      id: Date.now(),
      type: type,
      question: '',
      required: false,
      options: type === 'multiple_choice' ? ['', ''] : [],
      min: type === 'rating' ? 1 : null,
      max: type === 'rating' ? 5 : null
    };
    setNewSurvey({
      ...newSurvey,
      questions: [...newSurvey.questions, newQuestion]
    });
  };

  const updateQuestion = (questionId, field, value) => {
    setNewSurvey({
      ...newSurvey,
      questions: newSurvey.questions.map(q => 
        q.id === questionId ? { ...q, [field]: value } : q
      )
    });
  };

  const updateOption = (questionId, optionIndex, value) => {
    setNewSurvey({
      ...newSurvey,
      questions: newSurvey.questions.map(q => 
        q.id === questionId 
          ? { 
              ...q, 
              options: q.options.map((opt, idx) => 
                idx === optionIndex ? value : opt
              )
            } 
          : q
      )
    });
  };

  const addOption = (questionId) => {
    setNewSurvey({
      ...newSurvey,
      questions: newSurvey.questions.map(q => 
        q.id === questionId 
          ? { ...q, options: [...q.options, ''] }
          : q
      )
    });
  };

  const removeOption = (questionId, optionIndex) => {
    setNewSurvey({
      ...newSurvey,
      questions: newSurvey.questions.map(q => 
        q.id === questionId 
          ? { 
              ...q, 
              options: q.options.filter((_, idx) => idx !== optionIndex)
            }
          : q
      )
    });
  };

  const removeQuestion = (questionId) => {
    setNewSurvey({
      ...newSurvey,
      questions: newSurvey.questions.filter(q => q.id !== questionId)
    });
  };

  const moveQuestion = (questionId, direction) => {
    const questions = [...newSurvey.questions];
    const index = questions.findIndex(q => q.id === questionId);
    
    if (direction === 'up' && index > 0) {
      [questions[index], questions[index - 1]] = [questions[index - 1], questions[index]];
    } else if (direction === 'down' && index < questions.length - 1) {
      [questions[index], questions[index + 1]] = [questions[index + 1], questions[index]];
    }
    
    setNewSurvey({ ...newSurvey, questions });
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'active':
        return <span className="badge badge-success">Aktif</span>;
      case 'completed':
        return <span className="badge badge-secondary">Tamamlandı</span>;
      default:
        return <span className="badge badge-warning">Beklemede</span>;
    }
  };

  return (
    <div className="page-content">
      <div className="page-header">
        <div className="page-title">
          <h3>Anketler</h3>
          <p>Şirket anketlerini görüntüleyin ve yeni anketler oluşturun</p>
        </div>
        <div className="page-btn">
          <button 
            className="btn btn-primary"
            onClick={() => setShowCreateForm(true)}
          >
            <i className='bx bx-plus'></i>
            Yeni Anket Oluştur
          </button>
        </div>
      </div>

      {/* Yeni Anket Oluşturma Formu */}
      {showCreateForm && (
        <div className="modal-overlay" onClick={() => setShowCreateForm(false)}>
          <div className="modal-content-large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h4>Yeni Anket Oluştur</h4>
              <button 
                className="modal-close"
                onClick={() => {
                  setShowCreateForm(false);
                  setCurrentStep(1);
                  setNewSurvey({ title: '', description: '', deadline: '', questions: [] });
                }}
              >
                <i className='bx bx-x'></i>
              </button>
            </div>
            
            {/* Adım Göstergesi */}
            <div className="step-indicator">
              <div className={`step ${currentStep === 1 ? 'active' : ''}`}>
                <span className="step-number">1</span>
                <span className="step-title">Temel Bilgiler</span>
              </div>
              <div className={`step ${currentStep === 2 ? 'active' : ''}`}>
                <span className="step-number">2</span>
                <span className="step-title">Sorular</span>
              </div>
            </div>

            <form onSubmit={handleCreateSurvey}>
              <div className="modal-body">
                {currentStep === 1 && (
                  <>
                    <div className="form-group">
                      <label>Anket Başlığı</label>
                      <input
                        type="text"
                        className="form-control"
                        value={newSurvey.title}
                        onChange={(e) => setNewSurvey({...newSurvey, title: e.target.value})}
                        required
                        placeholder="Örn: Çalışan Memnuniyet Anketi 2024"
                      />
                    </div>
                    <div className="form-group">
                      <label>Açıklama</label>
                      <textarea
                        className="form-control"
                        rows="3"
                        value={newSurvey.description}
                        onChange={(e) => setNewSurvey({...newSurvey, description: e.target.value})}
                        required
                        placeholder="Anketin amacını ve kapsamını açıklayın..."
                      />
                    </div>
                    <div className="form-group">
                      <label>Bitiş Tarihi</label>
                      <input
                        type="date"
                        className="form-control"
                        value={newSurvey.deadline}
                        onChange={(e) => setNewSurvey({...newSurvey, deadline: e.target.value})}
                        required
                      />
                    </div>
                  </>
                )}

                {currentStep === 2 && (
                  <div className="questions-editor">
                    <div className="add-question-section">
                      <h5>Soru Ekle</h5>
                      <div className="question-type-buttons">
                        <button 
                          type="button" 
                          className="btn btn-outline-primary"
                          onClick={() => addQuestion('text')}
                        >
                          <i className='bx bx-text'></i>
                          Kısa Yanıt
                        </button>
                        <button 
                          type="button" 
                          className="btn btn-outline-primary"
                          onClick={() => addQuestion('textarea')}
                        >
                          <i className='bx bx-edit'></i>
                          Uzun Yanıt
                        </button>
                        <button 
                          type="button" 
                          className="btn btn-outline-primary"
                          onClick={() => addQuestion('multiple_choice')}
                        >
                          <i className='bx bx-list-ul'></i>
                          Çoktan Seçmeli
                        </button>
                        <button 
                          type="button" 
                          className="btn btn-outline-primary"
                          onClick={() => addQuestion('rating')}
                        >
                          <i className='bx bx-star'></i>
                          Derecelendirme
                        </button>
                      </div>
                    </div>

                    <div className="questions-list">
                      {newSurvey.questions.map((question, index) => (
                        <div key={question.id} className="question-item">
                          <div className="question-header">
                            <div className="question-number">Soru {index + 1}</div>
                            <div className="question-actions">
                              <button 
                                type="button"
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => moveQuestion(question.id, 'up')}
                                disabled={index === 0}
                              >
                                <i className='bx bx-up-arrow-alt'></i>
                              </button>
                              <button 
                                type="button"
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => moveQuestion(question.id, 'down')}
                                disabled={index === newSurvey.questions.length - 1}
                              >
                                <i className='bx bx-down-arrow-alt'></i>
                              </button>
                              <button 
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => removeQuestion(question.id)}
                              >
                                <i className='bx bx-trash'></i>
                              </button>
                            </div>
                          </div>

                          <div className="question-content">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control question-input"
                                value={question.question}
                                onChange={(e) => updateQuestion(question.id, 'question', e.target.value)}
                                placeholder="Sorunuzu yazın..."
                              />
                            </div>

                            {question.type === 'multiple_choice' && (
                              <div className="options-section">
                                <label>Seçenekler:</label>
                                {question.options.map((option, optionIndex) => (
                                  <div key={optionIndex} className="option-item">
                                    <input
                                      type="text"
                                      className="form-control option-input"
                                      value={option}
                                      onChange={(e) => updateOption(question.id, optionIndex, e.target.value)}
                                      placeholder={`Seçenek ${optionIndex + 1}`}
                                    />
                                    {question.options.length > 2 && (
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-outline-danger"
                                        onClick={() => removeOption(question.id, optionIndex)}
                                      >
                                        <i className='bx bx-x'></i>
                                      </button>
                                    )}
                                  </div>
                                ))}
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={() => addOption(question.id)}
                                >
                                  <i className='bx bx-plus'></i>
                                  Seçenek Ekle
                                </button>
                              </div>
                            )}

                            {question.type === 'rating' && (
                              <div className="rating-settings">
                                <div className="row">
                                  <div className="col-md-6">
                                    <label>Minimum Değer</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={question.min}
                                      onChange={(e) => updateQuestion(question.id, 'min', parseInt(e.target.value))}
                                      min="1"
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <label>Maksimum Değer</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={question.max}
                                      onChange={(e) => updateQuestion(question.id, 'max', parseInt(e.target.value))}
                                      min="2"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}

                            <div className="question-settings">
                              <label className="checkbox-label">
                                <input
                                  type="checkbox"
                                  checked={question.required}
                                  onChange={(e) => updateQuestion(question.id, 'required', e.target.checked)}
                                />
                                <span className="checkmark"></span>
                                Bu soru zorunlu
                              </label>
                            </div>
                          </div>
                        </div>
                      ))}

                      {newSurvey.questions.length === 0 && (
                        <div className="no-questions">
                          <i className='bx bx-help-circle'></i>
                          <p>Henüz soru eklenmedi. Yukarıdaki butonlardan soru ekleyebilirsiniz.</p>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
              
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => {
                    setShowCreateForm(false);
                    setCurrentStep(1);
                    setNewSurvey({ title: '', description: '', deadline: '', questions: [] });
                  }}
                >
                  İptal
                </button>
                
                {currentStep === 1 && (
                  <button 
                    type="button" 
                    className="btn btn-primary"
                    onClick={() => setCurrentStep(2)}
                    disabled={!newSurvey.title || !newSurvey.description || !newSurvey.deadline}
                  >
                    Sonraki Adım
                    <i className='bx bx-right-arrow-alt'></i>
                  </button>
                )}
                
                {currentStep === 2 && (
                  <>
                    <button 
                      type="button" 
                      className="btn btn-outline-primary"
                      onClick={() => setCurrentStep(1)}
                    >
                      <i className='bx bx-left-arrow-alt'></i>
                      Önceki Adım
                    </button>
                    <button 
                      type="submit" 
                      className="btn btn-primary"
                    >
                      <i className='bx bx-check'></i>
                      Anket Oluştur
                    </button>
                  </>
                )}
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Anket Listesi */}
      <div className="row">
        {surveys.map((survey) => (
          <div key={survey.id} className="col-lg-4 col-md-6">
            <div className="card survey-card">
              <div className="card-header">
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="card-title">{survey.title}</h5>
                  {getStatusBadge(survey.status)}
                </div>
              </div>
              <div className="card-body">
                <p className="card-text">{survey.description}</p>
                
                <div className="survey-stats">
                  <div className="stat-item">
                    <i className='bx bx-help-circle'></i>
                    <span>{survey.questions} Soru</span>
                  </div>
                  <div className="stat-item">
                    <i className='bx bx-user'></i>
                    <span>{survey.responses} Yanıt</span>
                  </div>
                  <div className="stat-item">
                    <i className='bx bx-calendar'></i>
                    <span>{new Date(survey.deadline).toLocaleDateString('tr-TR')}</span>
                  </div>
                </div>

                <div className="survey-meta">
                  <small className="text-muted">
                    Oluşturan: {survey.createdBy}
                  </small>
                </div>
              </div>
              <div className="card-footer">
                {survey.status === 'active' ? (
                  <button className="btn btn-primary btn-sm">
                    <i className='bx bx-edit'></i>
                    Anketi Doldur
                  </button>
                ) : (
                  <button className="btn btn-outline-secondary btn-sm" disabled>
                    <i className='bx bx-check'></i>
                    Tamamlandı
                  </button>
                )}
                <button className="btn btn-outline-info btn-sm ms-2">
                  <i className='bx bx-bar-chart'></i>
                  Sonuçları Gör
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Anket Oluşturma Rehberi */}
      <div className="row mt-4">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h5>Anket Oluşturma Rehberi</h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-4">
                  <div className="guide-item">
                    <div className="guide-icon">
                      <i className='bx bx-edit-alt'></i>
                    </div>
                    <h6>1. Anket Oluştur</h6>
                    <p>Başlık, açıklama ve bitiş tarihi belirleyerek yeni anket oluşturun.</p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="guide-item">
                    <div className="guide-icon">
                      <i className='bx bx-help-circle'></i>
                    </div>
                    <h6>2. Sorular Ekle</h6>
                    <p>Çoktan seçmeli, metin, derecelendirme gibi farklı soru tipleri ekleyin.</p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="guide-item">
                    <div className="guide-icon">
                      <i className='bx bx-send'></i>
                    </div>
                    <h6>3. Yayınla</h6>
                    <p>Anketi çalışanlarla paylaşın ve sonuçları takip edin.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .survey-card {
          height: 100%;
          transition: transform 0.2s;
        }
        
        .survey-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(0,0,0,0.1);
        }
        
        .survey-stats {
          display: flex;
          justify-content: space-between;
          margin: 15px 0;
          padding: 10px 0;
          border-top: 1px solid #eee;
          border-bottom: 1px solid #eee;
        }
        
        .stat-item {
          display: flex;
          align-items: center;
          gap: 5px;
          font-size: 0.9em;
          color: #666;
        }
        
        .stat-item i {
          font-size: 1.1em;
        }
        
        .survey-meta {
          margin-top: 10px;
        }
        
        .guide-item {
          text-align: center;
          padding: 20px;
        }
        
        .guide-icon {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 15px;
          color: white;
          font-size: 24px;
        }
        
        .guide-item h6 {
          margin-bottom: 10px;
          color: #333;
        }
        
        .guide-item p {
          color: #666;
          font-size: 0.9em;
        }
        
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }
        
        .modal-content {
          background: white;
          border-radius: 8px;
          width: 90%;
          max-width: 500px;
          max-height: 90vh;
          overflow-y: auto;
        }
        
        .modal-content-large {
          background: white;
          border-radius: 8px;
          width: 95%;
          max-width: 800px;
          max-height: 90vh;
          overflow-y: auto;
        }
        
        .modal-header {
          padding: 20px;
          border-bottom: 1px solid #eee;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .modal-close {
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #666;
        }
        
        .modal-body {
          padding: 20px;
        }
        
        .modal-footer {
          padding: 20px;
          border-top: 1px solid #eee;
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }
        
        .form-group {
          margin-bottom: 20px;
        }
        
        .form-group label {
          display: block;
          margin-bottom: 5px;
          font-weight: 500;
          color: #333;
        }
        
        .form-control {
          width: 100%;
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 14px;
        }
        
        .form-control:focus {
          outline: none;
          border-color: #667eea;
          box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
        }
        
        .badge {
          padding: 4px 8px;
          border-radius: 12px;
          font-size: 0.75em;
          font-weight: 500;
        }
        
        .badge-success {
          background-color: #d4edda;
          color: #155724;
        }
        
        .badge-secondary {
          background-color: #e2e3e5;
          color: #383d41;
        }
        
        .badge-warning {
          background-color: #fff3cd;
          color: #856404;
        }
        
        /* Adım Göstergesi */
        .step-indicator {
          display: flex;
          justify-content: center;
          margin: 20px 0;
          padding: 0 20px;
        }
        
        .step {
          display: flex;
          align-items: center;
          margin: 0 20px;
          color: #ccc;
        }
        
        .step.active {
          color: #667eea;
        }
        
        .step-number {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: #f0f0f0;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          font-weight: bold;
        }
        
        .step.active .step-number {
          background: #667eea;
          color: white;
        }
        
        .step-title {
          font-weight: 500;
        }
        
        /* Soru Editörü */
        .questions-editor {
          max-height: 60vh;
          overflow-y: auto;
        }
        
        .add-question-section {
          background: #f8f9fa;
          padding: 20px;
          border-radius: 8px;
          margin-bottom: 20px;
        }
        
        .add-question-section h5 {
          margin-bottom: 15px;
          color: #333;
        }
        
        .question-type-buttons {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 10px;
        }
        
        .question-type-buttons button {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 15px;
          border: 2px solid #e0e0e0;
          border-radius: 8px;
          background: white;
          transition: all 0.2s;
        }
        
        .question-type-buttons button:hover {
          border-color: #667eea;
          background: #f8f9ff;
        }
        
        .question-type-buttons button i {
          font-size: 24px;
          margin-bottom: 8px;
          color: #667eea;
        }
        
        .questions-list {
          space-y: 20px;
        }
        
        .question-item {
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          margin-bottom: 20px;
          background: white;
        }
        
        .question-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 15px 20px;
          background: #f8f9fa;
          border-bottom: 1px solid #e0e0e0;
          border-radius: 8px 8px 0 0;
        }
        
        .question-number {
          font-weight: 600;
          color: #333;
        }
        
        .question-actions {
          display: flex;
          gap: 5px;
        }
        
        .question-content {
          padding: 20px;
        }
        
        .question-input {
          font-size: 16px;
          font-weight: 500;
          border: none;
          border-bottom: 2px solid #e0e0e0;
          border-radius: 0;
          padding: 10px 0;
          background: transparent;
        }
        
        .question-input:focus {
          border-bottom-color: #667eea;
          box-shadow: none;
        }
        
        .options-section {
          margin-top: 20px;
        }
        
        .options-section label {
          display: block;
          margin-bottom: 10px;
          font-weight: 500;
          color: #333;
        }
        
        .option-item {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 10px;
        }
        
        .option-input {
          flex: 1;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
          padding: 8px 12px;
        }
        
        .rating-settings {
          margin-top: 20px;
          padding: 15px;
          background: #f8f9fa;
          border-radius: 6px;
        }
        
        .rating-settings label {
          font-weight: 500;
          color: #333;
          margin-bottom: 5px;
        }
        
        .question-settings {
          margin-top: 20px;
          padding-top: 15px;
          border-top: 1px solid #e0e0e0;
        }
        
        .checkbox-label {
          display: flex;
          align-items: center;
          cursor: pointer;
          font-weight: 500;
          color: #333;
        }
        
        .checkbox-label input[type="checkbox"] {
          margin-right: 10px;
          transform: scale(1.2);
        }
        
        .no-questions {
          text-align: center;
          padding: 40px 20px;
          color: #666;
        }
        
        .no-questions i {
          font-size: 48px;
          color: #ccc;
          margin-bottom: 15px;
        }
        
        .no-questions p {
          font-size: 16px;
          margin: 0;
        }
      `}</style>
    </div>
  );
};

export default SurveyPage;
